import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	displayText: {
		id: 'software.main.header.menu.manage-custom-filters-item.display-text',
		defaultMessage: 'Manage custom filters',
		description: 'Dropdown item which opens up Manage custom filters page',
	},
});
